import React from 'react';
import { Card, Typography } from 'antd';
import Icons from '@/components/third-party/Icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/App';
import { defaultColors } from '@/themes/antd-theme';

const { Title } = Typography;

const LineClearance = () => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const textColor = isDark ? '#ffffff' : '#1f2937';

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: isDark ? defaultColors.palette.gray[900] : '#f9fafb' }}>
      <Card
        className="shadow-sm"
        bordered={false}
        style={{ backgroundColor: isDark ? defaultColors.palette.gray[800] : '#ffffff' }}
        title={
          <div className="flex items-center gap-2">
            <Icons.Droplet className="text-blue-600" size={24} />
            <Title
              level={4}
              style={{
                color: textColor,
                margin: 0,
                padding: 0,
              }}
            >
              {t('Line Clearance')}
            </Title>
          </div>
        }
      >
        <div>LineClearance Content</div>
      </Card>
    </div>
  );
};

export default LineClearance;
